import { useState, useEffect } from "react";
import { networkState, NetworkMode } from "../lib/captainMesh/networkState";

export function useCaptainNetwork() {
  const [mode, setMode] = useState(() => networkState.getMode());

  useEffect(() => {
    const unsubscribe = networkState.subscribe((newMode) => {
      setMode(newMode);
    });
    return () => unsubscribe();
  }, []);

  return {
    mode,
    isOnline: mode === NetworkMode.SERVER_CONNECTED || mode === NetworkMode.RECONCILING,
    isOffline: mode === NetworkMode.SERVER_OFFLINE || mode === NetworkMode.LOCAL_ONLY || mode.startsWith("MESH"),
    isMeshActive: mode === NetworkMode.MESH_ACTIVE || mode === NetworkMode.MESH_DEGRADED,
    isLocalOnly: mode === NetworkMode.LOCAL_ONLY,
    isReconciling: mode === NetworkMode.RECONCILING,
  };
}
